import React from 'react'
import { useNavigate } from 'react-router-dom';
import { DASHBOARD_PAGE, LOGIN_PAGE } from '../constents/routesSrtings';
import { useSelector } from 'react-redux';


const Error = () => {
    const Navigate = useNavigate();
    const isUserAuthenticated = useSelector(store => store?.authStates?.isUserAuthenticated);
    const goToDashboardPage = () => {
        if (isUserAuthenticated) {
            Navigate(DASHBOARD_PAGE)
        }
        else {
            Navigate(LOGIN_PAGE);
        }
    }

    return (
        <div className=' w-screen h-screen flex items-center justify-center'>
            <h1 className=' text-2xl font-semibold'>May be your on broken url <span className=' text-3xl font-bold italic text-primary-800 cursor-pointer' onClick={() => goToDashboardPage()}>click</span> here to go back on site</h1>
        </div>
    )
}

export default Error;